/* eslint-disable react/jsx-closing-tag-location */
/* eslint-disable react/jsx-closing-bracket-location */
/* eslint-disable react/jsx-child-element-spacing */
import { Chip, Divider } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import Link from '@material-ui/core/Link';
import Typography from '@material-ui/core/Typography';
import InfoIcon from '@material-ui/icons/Info';
import StarIcon from '@material-ui/icons/Star';
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import ReactTooltip from 'react-tooltip';

import {
	CommaSeparator,
	GetFormat,
	convertToLangKey,
	getFirstDueInstallmentAndNext,
	getTotalInterestPaid
} from '../../AppUtil/AppUtil';
import RatingsService from '../../Service/RatingsService';
import { popUpForItemDescribed } from '../../SweetAlertUtil/util';
import BaseField from '../Common/Loans/Base';
import MobileFooter from '../Common/Profile/MobileFooter';
import PageHeaderTitle from '../Common/Profile/PageHeaderTitle';
import RatingStars from '../Profile/BaseProfile/ratingStars';
import StatesService from './../../Service/StatesService';
import EditRating from './EditRating';
import PaymentBadge from './PaymentBadge';
import StateBadge from './StateBadge';

import Loader from '../Common/Loader';

const LOAN_STATES = window.AppConfig.LOAN_STATES;
const PAYMENT_STATUS = window.AppConfig.PAYMENT_STATUS;

class BaseDetail extends Component {
	constructor(props) {
		super(props);
		this.state = {
			stateName: '',
			_isLoading: true,
			ratingData: 0,
			newRating: 0,
			_openEditScreen: '',
			_openScreen: ''
		};
		this.getStateData();
	}

	getStateData = async () => {
		const stateData = await StatesService.getStateById(this.props.loanObject.lender_state);
		this.setState({ stateName: stateData?.name, _isLoading: false });
		if (this.props.loanObject.state === 'COMPLETED') {
			this.getRating();
		}
	};

	getRating = async () => {
		let ratingResponse;
		let newRating;
		this.setState({ _isLoading: true });
		if (this.props.headingName === 'label.borrower') {
			if (this.props.loanObject.loan_type === 'LEND') {
				ratingResponse = await RatingsService.getUserRating(
					this.props.loanObject.accepted_by,
					'?loan_id=' + this.props.loanObject.id
				);
				newRating = await RatingsService.listRatingByLoanId(+this.props.loanObject?.id);
			}

			if (this.props.loanObject.loan_type === 'BORROW') {
				ratingResponse = await RatingsService.getUserRating(
					this.props.loanObject.created_by,
					'?loan_id=' + this.props.loanObject.id
				);
				newRating = await RatingsService.listRatingByLoanId(+this.props.loanObject?.id);
			}
		}
		if (this.props.headingName === 'label.lender') {
			if (this.props.loanObject.loan_type === 'LEND') {
				ratingResponse = await RatingsService.getUserRating(
					this.props.loanObject.created_by,
					'?loan_id=' + this.props.loanObject.id
				);
				newRating = await RatingsService.listRatingByLoanId(+this.props.loanObject?.id);
			}
			if (this.props.loanObject.loan_type === 'BORROW') {
				ratingResponse = await RatingsService.getUserRating(
					this.props.loanObject.accepted_by,
					'?loan_id=' + this.props.loanObject.id
				);
				newRating = await RatingsService.listRatingByLoanId(+this.props.loanObject?.id);
			}
		}

		this.setState({
			ratingData: ratingResponse || 0,
			newRating: newRating ? newRating[0] : [],
			_isLoading: false
		});
	};

	openRatingScreen = screen => {
		this.setState({
			_openScreen: 'EDIT_RATING',
			_openEditScreen: screen
		});
	};

	backToSummaryScreen = ratingVal => {
		this.setState({
			_openScreen: ''
			// ratingData: ratingVal.
		});
		this.getStateData();
	};

	backSummaryScreen = () => {
		this.setState({
			_openScreen: ''
		});
	};

	render() {
		const username = this.props.loanObject.name
			?.split(' ')
			.map((m, index) => m.charAt(0).toUpperCase() + m.slice(1))
			.join(' ');

		// NOSONAR
		const { classes } = this.props;
		const { t } = this.props;
		const wallet_connected = this.props.currentUser.profile.wallet_connected || false;

		// the issue comes from the fact that the date is not in the correct format, so we need to add ".000Z" to the end of the date if it doesn't have it
		let installmentDate = this.props.loanObject.next_installment_details
			? this.props.loanObject.next_installment_details.installment_date
			: this.props.loanObject.first_installment_date;

		// Check if the installment_date has a timezone format
		const hasTimezoneFormat = /Z$/.test(installmentDate);

		// If it doesn't have a timezone format, append ".000Z"
		if (!hasTimezoneFormat) {
			installmentDate = `${installmentDate}Z`;
		}

		const { firstDueInstallment } = getFirstDueInstallmentAndNext(this.props.loanObject.installments);

		if (this.state._openScreen === 'EDIT_RATING') {
			return (
				<EditRating
					backEditScreen={this.backSummaryScreen}
					closeEditScreen={this.backToSummaryScreen}
					headingName={this.props.headingName}
					loading={this.state._isLoading}
					loanObject={this.props.loanObject}
					openScreen={this.state._openEditScreen}
					ratingData={this.state.newRating}
					setCurrentUser={this.props.setCurrentUser}
				/>
			);
		} else {
			return (
				<section className="loan_details_review">
					<PageHeaderTitle className="p-x-16" title="Loan Details" onClick={this.props.closeLoanDetail} />

					{/* <Container component="main" maxWidth="md"> */}
					<Grid container className="loan_details" id="reduce-width" justify="center">
						<Grid id="shadow-round" item sm={12} xs={12} justify="center">
							<Grid sm={12} xs={12} style={{ padding: '1rem' }}>
								<div className="loan-details-header">
									{this.props.generateAction()}
									{this.props.loanObject.state === 'COMPLETED' ? (
										<div
											className="loan-details-header-content"
											onClick={e => {
												e.preventDefault();
												this.openRatingScreen('NAME_INFO');
											}}>
											<div
												className="loan-details-btn"
												style={{
													backgroundColor: '#FFC63C',
													textAlign: 'center'
												}}>
												<StarIcon
													style={{
														color: 'FFFFFF',
														fontSize: 40,
														textAlign: 'center',
														marginTop: '20%'
													}}
												/>
											</div>
											<p>
												{(this.props.headingName === 'label.borrower' &&
													this.state.newRating?.borrower_rating > 0) ||
												(this.props.headingName === 'label.lender' &&
													this.state.newRating?.lender_rating > 0)
													? 'View Rate'
													: t('buttons.rate_here')}
											</p>
										</div>
									) : null}
									{this.props.genrateButton(
										'buttons.view_amortization_table',
										this.props.openAmortizationTable
									)}
								</div>
							</Grid>
							{/* <Paper className="loan-details-body"> */}
							{/* <Base classes={classes}> */}
							<Grid className="loan-list" sm={12} xs={12}>
								<Typography component="h3" variant="h5">
									<>
										<BaseField
											customContainerClass="base-flex-container"
											customHeadingClass="black-heading"
											customValueClass="bold loan_amount"
											heading={t('view_detail.loan_id')}
											value={this.props.loanObject.id}
										/>
										<BaseField
											customContainerClass="base-flex-container heading_name_container"
											customHeadingClass="black-heading"
											customValueClass="light-blue bold"
											heading={t(this.props.headingName)}
											value={
												<div>
													<Link
														className="loan_review_user_name"
														href="#"
														onClick={e => {
															e.preventDefault();
															this.props.onClickForName();
														}}
														// style={{ fontSize: 'medium' }}
														variant="body2">
														{username}
													</Link>{' '}
													<br />
													{(() => {
														if (this.props.loanObject.state === 'COMPLETED') {
															return (
																<span id="name-rating">
																	{(() => {
																		if (
																			(this.props.headingName ===
																				'label.borrower' &&
																				this.state.newRating?.borrower_rating >
																					0) ||
																			(this.props.headingName ===
																				'label.lender' &&
																				this.state.newRating?.lender_rating > 0)
																		) {
																			return (
																				<>
																					<div>
																						<RatingStars
																							stars={
																								this.props
																									.headingName ===
																								'label.borrower'
																									? this.state
																											.newRating
																											?.borrower_rating
																									: this.state
																											.newRating
																											?.lender_rating
																							}
																						/>
																					</div>
																					<p className="rating-score">
																						Rating:{' '}
																						{this.props.headingName ===
																						'label.borrower'
																							? this.state.newRating
																									?.borrower_rating
																							: this.state.newRating
																									?.lender_rating}
																					</p>
																				</>
																			);
																		} else {
																			return null;
																		}
																	})()}
																</span>
															);
														} else {
															return null;
														}
													})()}
												</div>
											}
										/>
										<BaseField
											customContainerClass="base-flex-container"
											customHeadingClass="black-heading"
											heading={t('view_detail.guarantor')}
											value={
												this.props.loanObject.guarantor_exist ? (
													<div>
														<Link
															href="#"
															onClick={e => {
																e.preventDefault();
																this.props.onClickShowGuarator();
															}}
															style={{ fontSize: 'medium' }}
															variant="body2">
															{this.props.loanObject.guarantor_data.name}
														</Link>{' '}
													</div>
												) : (
													'None'
												)
											}
										/>
										<Divider variant="middle" className="mobile_divider fullw" />
										<BaseField
											customContainerClass="base-flex-container loan_status_container"
											customHeadingClass="black-heading loan_status"
											customValueClass={`bold loan_amount ${
												this.props.loanObject.state === 'APPROVE' ? 'approved' : 'pending'
											}`}
											heading={t('view_detail.loan_status')}
											value={<StateBadge state={this.props.loanObject.state} />}
										/>
										<Divider variant="middle" className="mobile_divider fullw" />
										<BaseField
											customContainerClass="base-flex-container"
											customHeadingClass="black-heading loan_amount_heading"
											customValueClass="bold loan_amount"
											heading={t('view_detail.loan_amount')}
											value={`₱${CommaSeparator(this.props.loanObject.principal)}`}
										/>
										<BaseField
											customContainerClass="base-flex-container"
											customHeadingClass="black-heading interest_rate_heading"
											customValueClass="bold loan_amount"
											heading={
												<span style={{ minWidth: '160px', display: 'block' }}>
													{t('view_detail.interest_rate')}{' '}
													<span data-for="interest-rate" data-tip id="interest-rate">
														<InfoIcon color="disabled" />
													</span>
												</span>
											}
											value={`${this.props.loanObject.annual_rate}%`}
										/>
										<BaseField
											customContainerClass="base-flex-container"
											customHeadingClass="black-heading"
											heading={t('view_detail.frequency')}
											value={t(`label.${convertToLangKey(this.props.loanObject.frequency)}`)}
										/>

										<BaseField
											customContainerClass="base-flex-container no_of_installments_container"
											customHeadingClass="black-heading no_of_installments_heading"
											customValueClass="bold loan_amount"
											heading={t('view_detail.number_of_installments')}
											value={this.props.loanObject.no_of_installments}
										/>

										<BaseField
											customContainerClass="base-flex-container principal-container"
											customHeadingClass="black-heading principal"
											customValueClass="bold loan_amount"
											heading={
												<span style={{ minWidth: '160px', display: 'block' }}>
													{t('view_detail.total_interest_to_be_paid')}{' '}
													<span
														data-for="interest-to-be-paid"
														data-tip
														id="interest-to-be-paid">
														<InfoIcon color="disabled" />
													</span>
												</span>
											}
											value={
												<>
													₱
													{CommaSeparator(
														parseFloat(
															this.props.loanObject.installments.length > 0
																? getTotalInterestPaid(this.props.loanObject)
																: this.props.loanObject.total -
																		this.props.loanObject.principal
														).toFixed(2)
													)}
												</>
											}
										/>

										<BaseField
											customContainerClass="base-flex-container principal-container"
											customHeadingClass="black-heading principal"
											customValueClass="bold loan_amount"
											heading={
												<span style={{ minWidth: '160px', display: 'block' }}>
													{t('view_detail.amount_payable_per_installment')}{' '}
													<span data-for="amount-payable" data-tip id="amount-payable">
														<InfoIcon color="disabled" />
													</span>
												</span>
											}
											value={
												<>
													₱
													{CommaSeparator(
														parseFloat(
															this.props.loanObject.installments.length > 0
																? this.props.loanObject.installments[0].emi_amount
																: this.props.loanObject.total
														).toFixed(2)
													)}
												</>
											}
										/>

										<Divider variant="middle" className="mobile_divider fullw" />
										<BaseField
											customContainerClass="base-flex-container"
											customHeadingClass="black-heading"
											customValueClass="bold loan_amount"
											heading={t('view_detail.loan_start_date')}
											value={
												this.props.loanObject.disbursal_date
													? GetFormat(this.props.loanObject.disbursal_date)
													: GetFormat(this.props.loanObject.start_date)
											}
										/>
										<BaseField
											customContainerClass="base-flex-container"
											customHeadingClass="black-heading"
											heading={t('view_detail.loan_end_date')}
											customValueClass="bold loan_amount"
											value={GetFormat(this.props.loanObject.end_date)}
										/>
										<Divider variant="middle" className="mobile_divider fullw" />
										{this.props.loanObject.state !== LOAN_STATES.COMPLETED && (
											<>
												<BaseField
													customContainerClass="base-flex-container"
													customHeadingClass="black-heading"
													customValueClass="bold loan_amount"
													heading={t('view_detail.next_payment_date')}
													value={GetFormat(installmentDate)}
												/>
												<BaseField
													customContainerClass="base-flex-container"
													customHeadingClass="black-heading next_payment_amount_heading"
													customValueClass="loan_amount"
													heading={t('view_detail.next_payment_amount')}
													value={
														<>
															₱
															{CommaSeparator(
																parseFloat(
																	this.props.loanObject.installments.length > 0 &&
																		firstDueInstallment
																		? firstDueInstallment.emi_amount
																		: this.props.loanObject.installments[0]
																				.emi_amount
																).toFixed(2)
															)}
														</>
													}
												/>
												<Divider variant="middle" className="mobile_divider fullw" />
											</>
										)}
										<BaseField
											customContainerClass="base-flex-container"
											customHeadingClass="black-heading loan_purpose_heading"
											customValueClass="bold loan_amount"
											heading={t('view_detail.loan_purpose')}
											value={
												this.props.loanObject.loan_workflow_id === 3 ? (
													<Link
														href="#"
														onClick={e => {
															e.preventDefault();
															popUpForItemDescribed(this.props.loanObject.item_purchased);
														}}
														style={{ fontSize: 'medium' }}>
														{t('view_detail.pay_for_something')}
													</Link>
												) : this.props.loanObject.reason ? (
													this.props.loanObject.reason
												) : (
													'N/A'
												)
											}
										/>
										<BaseField
											customContainerClass="base-flex-container"
											customHeadingClass="black-heading"
											heading={t('view_detail.collateral')}
											value={this.props.loanObject.collateral || t('profile.none')}
										/>
										<BaseField
											customContainerClass="base-flex-container"
											customHeadingClass="black-heading"
											heading={t('view_detail.lenders_state')}
											value={this.state.stateName}
										/>
										<Divider variant="middle" className="mobile_divider fullw" />
										<BaseField
											customContainerClass="base-flex-container"
											customHeadingClass="black-heading"
											heading={t('view_detail.bank_account')}
											value={
												!wallet_connected ? (
													<Link
														href="#"
														onClick={e => {
															e.preventDefault();
															this.props.addBankAccount();
														}}
														style={{ fontSize: 'medium' }}
														variant="body2">
														{t('view_detail.add_account')}
													</Link>
												) : (
													'Connected'
												)
											}
										/>
										<BaseField
											customContainerClass="base-flex-container"
											customHeadingClass="black-heading loan_funding_status_heading"
											customValueClass="btn-bottom"
											heading={
												<>
													{t('view_detail.loan_funding_status')}{' '}
													<span
														className="loan_funding_tooltip"
														data-for="max-tooltip"
														data-tip
														id="max-tooltip">
														<InfoIcon color="disabled" />
													</span>
												</>
											}
											value={(() => {
												if (
													this.props.loanObject.state === LOAN_STATES.APPROVE ||
													this.props.loanObject.state === LOAN_STATES.COMPLETED
												) {
													if (this.props.loanObject.latest_disbursal_mode) {
														if (this.props.loanObject.latest_disbursal_mode === 'ACH') {
															return <PaymentBadge status={PAYMENT_STATUS.COMPLETED} />;
														} else if (
															this.props.loanObject.latest_disbursal_mode === 'OFFLINE'
														) {
															return <PaymentBadge status={PAYMENT_STATUS.CHEQUE_CASH} />;
														} else {
															return <PaymentBadge status={'NA'} />;
														}
													} else {
														if (this.props.loanObject.disbursal_mode === 'ACH') {
															return <PaymentBadge status={PAYMENT_STATUS.COMPLETED} />;
														} else if (this.props.loanObject.disbursal_mode === 'OFFLINE') {
															return <PaymentBadge status={PAYMENT_STATUS.CHEQUE_CASH} />;
														} else {
															return <PaymentBadge status={'NA'} />;
														}
													}
												} else if (this.props.loanObject.state === LOAN_STATES.PENDING) {
													return (
														<Chip
															color="primary"
															label={t('view_detail.pending_loan_acceptance')}
															size="small"
															style={{
																backgroundColor: 'yellow',
																color: 'black'
															}}
														/>
													);
												} else {
													if (
														this.props.loanObject.disbursal_mode === 'ACH' ||
														this.props.loanObject.latest_disbursal_mode === 'ACH'
													) {
														if (!this.props.loanObject.disbursal_mode) {
															return (
																<Chip
																	color="primary"
																	label={t('view_detail.pending_loan_acceptance')}
																	size="small"
																	style={{
																		backgroundColor: 'yellow',
																		color: 'black'
																	}}
																/>
															);
														}

														return (
															<Chip
																label={t(`payment_status.${PAYMENT_STATUS.ACH}`)}
																size="small"
																style={{
																	backgroundColor: '#27B88D',
																	color: 'black',

																	fontWeight: 'bolder',
																	fontSize: '12px',
																	padding: '2px'
																}}
															/>
														);
													} else if (
														this.props.loanObject.disbursal_mode === 'OFFLINE' ||
														this.props.loanObject.latest_disbursal_mode === 'OFFLINE'
													) {
														if (!this.props.loanObject.disbursal_mode) {
															return (
																<Chip
																	color="primary"
																	label={t('view_detail.pending_loan_acceptance')}
																	size="small"
																	style={{
																		backgroundColor: 'yellow',
																		color: 'black'
																	}}
																/>
															);
														}

														return (
															<Chip
																label={t(
																	`payment_status.${PAYMENT_STATUS.CHEQUE_CASH}`
																)}
																size="small"
																style={{
																	backgroundColor: '#27B88D',
																	color: 'black',

																	fontWeight: 'bolder',
																	fontSize: '12px',
																	padding: '2px'
																}}
															/>
														);
													} else {
														return (
															<Chip
																label="N/A"
																size="small"
																style={{
																	backgroundColor: '#27B88D',
																	color: 'black',

																	fontWeight: 'bolder',
																	fontSize: '12px',
																	padding: '2px'
																}}
															/>
														);
													}
												}
											})()}
										/>
										<BaseField
											customContainerClass="base-flex-container"
											customHeadingClass="black-heading additional_terms_heading"
											heading={t('view_detail.additional_terms_conditions')}
											value={this.props.loanObject.additional_terms || t('profile.none')}
										/>
									</>
								</Typography>
							</Grid>
							{/* </Base> */}
							<ReactTooltip
								aria-haspopup="true"
								className="customTheme"
								effect="solid"
								id="min-tooltip"
								overridePosition={({ left, top }, currentEvent, currentTarget, node) => {
									const d = document.documentElement;
									left = Math.min(d.clientWidth - node.clientWidth, left);
									top = Math.min(d.clientHeight - node.clientHeight, top);
									left = Math.max(0, left);
									top = Math.max(0, top);
									return { top, left };
								}}
								role="min-tooltip">
								{t('view_detail.tooltip_principal_interest_rate')}
								<br />
							</ReactTooltip>

							<ReactTooltip
								aria-haspopup="true"
								className="customTheme"
								overridePosition={({ left, top }, currentEvent, currentTarget, node) => {
									const d = document.documentElement;
									left = Math.min(d.clientWidth - node.clientWidth, left);
									top = Math.min(d.clientHeight - node.clientHeight, top);
									left = Math.max(0, left);
									top = Math.max(0, top);
									return { top, left };
								}}
								effect="solid"
								id="interest-rate"
								place="top"
								role="interest-rate">
								{t('view_detail.tooltip_interest_rate')}
								<br />
							</ReactTooltip>

							<ReactTooltip
								aria-haspopup="true"
								className="customTheme"
								overridePosition={({ left, top }, currentEvent, currentTarget, node) => {
									const d = document.documentElement;
									left = Math.min(d.clientWidth - node.clientWidth, left);
									top = Math.min(d.clientHeight - node.clientHeight, top);
									left = Math.max(0, left);
									top = Math.max(0, top);
									return { top, left };
								}}
								effect="solid"
								id="interest-to-be-paid"
								place="top"
								role="interest-to-be-paid">
								{t('view_detail.tooltip_total_interest_to_be_paid')}
								<br />
							</ReactTooltip>

							<ReactTooltip
								aria-haspopup="true"
								className="customTheme"
								effect="solid"
								id="amount-payable"
								overridePosition={({ left, top }, currentEvent, currentTarget, node) => {
									const d = document.documentElement;
									left = Math.min(d.clientWidth - node.clientWidth, left);
									top = Math.min(d.clientHeight - node.clientHeight, top);
									left = Math.max(0, left);
									top = Math.max(0, top);
									return { top, left };
								}}
								place="top"
								role="amount-payable">
								{t('view_detail.tooltip_amount_payable_per_installment')}
								<br />
							</ReactTooltip>

							<ReactTooltip
								aria-haspopup="true"
								className="customTheme"
								effect="solid"
								id="max-tooltip"
								overridePosition={({ left, top }, currentEvent, currentTarget, node) => {
									const d = document.documentElement;
									left = Math.min(d.clientWidth - node.clientWidth, left);
									top = Math.min(d.clientHeight - node.clientHeight, top);
									left = Math.max(0, left);
									top = Math.max(0, top);
									return { top, left };
								}}
								role="max-tooltip">
								Funds Transfer in Progress = The Lender will be transferring
								<br />
								the loan funds from their wallet to yours
								<br />
								Check/Cash = The Lender will be providing the
								<br />
								funds via cash or check on a specific date
								<br />
								Pending Loan Acceptance = The loan is awaiting
								<br />
								final approval by the other party
								{/* <Trans i18nKey="view_detail.tooltip_funding_status">
									Funds Transfer in Progress = The Lender will be transferring
									<br />
									the loan funds from their wallet to yours
									<br />
									Check/Cash = The Lender will be providing the
									<br />
									funds via cash or check on a specific date
									<br />
									Pending Loan Acceptance = The loan is awaiting
									<br />
									final approval by the other party
								</Trans> */}
							</ReactTooltip>
							<ReactTooltip
								aria-haspopup="true"
								effect="solid"
								id="view-detail"
								place="top"
								role="view-detail">
								{t('label.view_details')}
							</ReactTooltip>
							{/* </Paper> */}
						</Grid>
					</Grid>
					<MobileFooter onClick={this.props.closeLoanDetail} />
					{this.state._isLoading && <Loader />}
					{/* </Container> */}
				</section>
			);
		}
	}
}

export default withTranslation()(BaseDetail);
